import Vue from 'vue'

import carousel from 'vue-owl-carousel'
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('carousel', carousel)
